import { render } from "./dialog-modal.vue?vue&type=template&id=f1aed194&scoped=true"
import script from "./dialog-modal.vue?vue&type=script&lang=js"
export * from "./dialog-modal.vue?vue&type=script&lang=js"

import "./dialog-modal.vue?vue&type=style&index=0&id=f1aed194&scoped=true&lang=css"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1aed194"]])

export default __exports__